import { AccountsClient } from '@accounts/client';
import { AccountsClientPassword } from '@accounts/client-password';
import { AccountsGraphQLClient } from '@accounts/graphql-client';
import { apolloClient } from '../api/client.js';

const graphQLInterface = new AccountsGraphQLClient({ graphQLClient: apolloClient });

export const accountsClient = new AccountsClient(
  { tokenStorage: localStorage, storagePrefix: 'accounts:' },
  graphQLInterface
);

export const accountsPassword = new AccountsClientPassword(accountsClient);

/**
 * Normalize phone number with +1 default
 * @param {string} phone
 */
export function normalizePhone(phone) {
  const trimmed = phone.trim();
  if (!trimmed) return '';
  return trimmed.startsWith('+') ? trimmed : `+1${trimmed}`;
}
